/** Talks to the Worker. Every change carries the x-mcds header the server requires. */
export class ApiError extends Error {
  constructor(public status: number, message: string, public data: Record<string, unknown> = {}) {
    super(message);
  }
}

let onSignedOut: () => void = () => {};
export const setSignedOutHandler = (f: () => void) => (onSignedOut = f);

export async function api<T = any>(path: string, opts: { method?: string; body?: unknown; raw?: Blob | ArrayBuffer; type?: string; form?: FormData } = {}): Promise<T> {
  const method = opts.method || (opts.body !== undefined || opts.raw || opts.form ? "POST" : "GET");
  const headers: Record<string, string> = { "x-mcds": "1" };
  if (opts.body !== undefined) headers["content-type"] = "application/json";
  if (opts.raw && opts.type) headers["content-type"] = opts.type;
  let res: Response;
  try {
    res = await fetch(path, {
      method,
      headers,
      credentials: "same-origin",
      body: opts.form ?? opts.raw ?? (opts.body !== undefined ? JSON.stringify(opts.body) : undefined),
    });
  } catch {
    throw new ApiError(0, "You seem to be offline. Check your connection and try again.");
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    if (res.status === 401 && (data as any).signedOut) onSignedOut();
    throw new ApiError(res.status, (data as any).error || "Something went wrong. Please try again.", data as Record<string, unknown>);
  }
  return data as T;
}
